import escapeRegExp from 'lodash/escapeRegExp';


export function getVimeoOpts(url){
	const vimeoRegex = "([a-zA-Z0-9]*)$";
	let regexString = escapeRegExp('player.vimeo.com/video/')
		+ `(${vimeoRegex})$`;
	let match = new RegExp(regexString, 'i').exec(url);
	if (match && match[1]){
		let id = match[1];
		return {
			techOrder: ['vimeo'],
			sources: [{
				"type": 'video/vimeo',
				"src": `https://vimeo.com/${id}`
			}],
			vimeo: {"iv_load_policy": 1}
		}
	}
	return false;
}


export function getYoutubeOpts(url){
	const youtubeRegex = "[a-zA-Z0-9_-]{11}";
	let regexString = escapeRegExp('youtube.com/embed/')
		+ `(${youtubeRegex})`;
	let match = new RegExp(regexString).exec(url);
	if (match && match[1]){
		let id = match[1];
		return {
			techOrder: ['youtube'],
			sources: [{
				"type": 'video/youtube',
				"src": `https://www.youtube.com/watch?v=${id}`
			}],
			ytControls: 2
		}
	}
	return false;
}